import { EventNames } from '@farmasiet/frontendcore-reactcomponents';

import { CooledProductsConflictItem } from './CooledProductsConflictItem';

export interface CooledProductsConflictEventDetail {
    product: CooledProductsConflictItem;
    onThisKept: () => void;
    onConflictedKept?: () => void;
}

export class CooledProductsConflictEvent {
    static create(detail: CooledProductsConflictEventDetail): CustomEvent<CooledProductsConflictEventDetail> {
        return new CustomEvent(EventNames.CooledProductsConflict, { detail });
    }
}
